<template>
  <div class="verify-card" :class="{ 'hide': !isVisible }">
    <div class="disabled" v-if="settings.disabled">
      <img src="../../../public/custom/images/lock.svg" class="lock-img" alt="Lock">
    </div>
    <div class="verify-data">
      <img src="../../../public/custom/images/green-mark.svg" class="verify-img" alt="mark">
      <div class="title">
        {{ $t(`message.profile.verifyCards.${settings.name}.title`) }}
      </div>
      <div class="desc">
        {{ $t(`message.profile.verifyCards.${settings.name}.${descKey}`) }}
      </div>
    </div>

    <base-button @click="$emit('action', settings.name)" :text="$t(`message.profile.verifyCards.${settings.name}.btn`)" class="btn"/>
    
  </div>
</template>

<script>
import BaseButton from '../../components/base/BaseButton.vue';

export default {
  name: 'verifyCard',
  components: {
    BaseButton
  },
  props: {
    settings: {
      type: Object,
      default: function() {
        return {
          name: 'agreement',
          disabled: false,
          visible: false
        }
      }
    }
  },
  computed: {
    isVisible() {
      return this.settings.visible;
    },
    descKey() {
      return this.settings.descKey || 'desc';
    }
  }
}
</script>

<style lang="scss" scoped>
  .verify-card {
    box-sizing: border-box;
    border-width: 0;
    border-style: solid;
    border-color: #e5e7eb;
    display: flex;
    flex-direction: column;
    row-gap: 24px;
    align-items: flex-start;
    justify-content: space-between;
    text-align: left;
    width: 100%;
    min-width: 0;
    max-width: none;
    padding: 24px;
    position: relative;
    border-radius: 12px;
    background-color: #f8f8f8;
  }

  .disabled {
    width: 100%;
    height: 100%;
    border-radius: 12px;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    -webkit-backdrop-filter: grayscale(1);
    backdrop-filter: grayscale(1);
    background-color: hsla(0, 0%, 97%, .44);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .lock-img {
    width: 48px;
  }

  .verify-data {
    width: 100%;
    display: flex;
    flex-direction: column;
    row-gap: 8px;
  }

  .verify-img {
    width: 24px; 
  }

  .title {
    font-weight: 600;
    line-height: 24px;
    font-size: 16px;
  }

  .desc {
    font-size: 14px;
    line-height: 22px;
  }

  .btn {
    width: max-content;
    max-height: 40px;
    min-height: 40px;
    padding: .5rem 1rem;
    box-sizing: border-box;
    justify-content: center;
    gap: 8px;
    border: none;
    outline: none;
    border-radius: 10px;
    font-weight: 600;
    font-size: 14px;

    &:hover {
      background-color: #33a568;
    }
  }

  .hide {
    display: none;
  }

  @media screen and (max-width: 360px) {
    .verify-card {
      row-gap: 16px;
      padding: 18px;
    }

    .btn {
      width: 100%;
    }
  }
</style>